/**
 * Vue 全局权限检查插件
 * 在 main.js 中注册此插件后，可以在任何组件中使用 this.$hasButtonPermission() 等方法
 */

import {
  isAdmin,
  hasButtonPermission,
  hasMenuPermission,
  getMenuButtons,
  getUserButtonCodes,
  checkMultipleButtonPermissions,
  getLoginUserInfo
} from '@/utils/buttonPermission'

export default {
  install(Vue) {
    // 全局方法
    Vue.prototype.$hasButtonPermission = hasButtonPermission
    Vue.prototype.$hasMenuPermission = hasMenuPermission
    Vue.prototype.$isAdmin = isAdmin
    Vue.prototype.$getMenuButtons = getMenuButtons
    Vue.prototype.$getUserButtonCodes = getUserButtonCodes
    Vue.prototype.$checkMultipleButtonPermissions = checkMultipleButtonPermissions
    Vue.prototype.$getLoginUserInfo = getLoginUserInfo

    // 全局过滤器 - 用于在模板中检查权限
    Vue.filter('hasButtonPermission', (buttonCode) => {
      return hasButtonPermission(buttonCode)
    })

    Vue.filter('hasMenuPermission', (menuCode) => {
      return hasMenuPermission(menuCode)
    })
  }
}
